import Search from './Search'

export default Search



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Search/index.js